import React from 'react';
import './ModernCard.css';

function ModernCard({ 
  children, 
  title, 
  subtitle,
  icon,
  variant = 'default', // default, gradient, glass, stat
  className = '',
  onClick,
  hoverable = false,
  glow = false,
  delay = 0
}) {
  return (
    <div 
      className={`modern-card ${variant} ${hoverable ? 'hoverable' : ''} ${glow ? 'glow' : ''} ${className}`}
      onClick={onClick}
      style={{ animationDelay: `${delay}s` }}
    >
      {(title || icon) && (
        <div className="card-header">
          {icon && <span className="card-icon">{icon}</span>}
          <div className="card-titles">
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
        </div>
      )}
      <div className="card-body">
        {children}
      </div>
    </div>
  );
}

// Stat Card Component
export function StatCard({ 
  value, 
  label, 
  icon, 
  trend, 
  trendValue,
  color = 'primary',
  delay = 0,
  onClick = null
}) {
  const colors = {
    primary: { gradient: 'linear-gradient(135deg, #1A2811 0%, #2a4019 100%)', shadow: 'rgba(26, 40, 17, 0.35)' },
    success: { gradient: 'linear-gradient(135deg, #1A2811 0%, #2a4019 100%)', shadow: 'rgba(26, 40, 17, 0.3)' },
    warning: { gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', shadow: 'rgba(245, 158, 11, 0.3)' },
    danger: { gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', shadow: 'rgba(239, 68, 68, 0.3)' },
    info: { gradient: 'linear-gradient(135deg, #4ecdc4 0%, #22c1c3 100%)', shadow: 'rgba(78, 205, 196, 0.3)' },
  };

  const colorStyle = colors[color] || colors.primary;

  return (
    <div 
      className={`stat-card stat-card-${color} ${onClick ? 'clickable' : ''}`}
      style={{ 
        '--card-gradient': colorStyle.gradient,
        '--card-shadow': colorStyle.shadow,
        animationDelay: `${delay}s`,
        cursor: onClick ? 'pointer' : 'default'
      }}
      onClick={onClick}
    >
      <div className="stat-icon-wrapper">
        <span className="stat-icon">{icon}</span>
      </div>
      <div className="stat-content">
        <span className="stat-value">{value}</span>
        <span className="stat-label">{label}</span>
        {trend && (
          <div className={`stat-trend ${trend}`}>
            <span>{trend === 'up' ? '↑' : '↓'}</span>
            <span>{trendValue}</span>
          </div>
        )}
      </div>
      <div className="stat-decoration"></div>
    </div>
  );
}

export default ModernCard;

